document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll(".grabday-add-cart").forEach(function(button){

        button.addEventListener("click", function(){

            let variant = this.dataset.variant;

            let btn = this;

            btn.disabled = true;
            btn.innerHTML = "ADDING...";

            fetch('/cart/add.js',{

                method:'POST',

                headers:{
                    'Content-Type':'application/json'
                },

                body:JSON.stringify({

                    id:variant,
                    quantity:1

                })

            })

            .then(response=>response.json())

            .then(data=>{

                btn.innerHTML="✓ ADDED";

                fetch('/cart.js')
                .then(res=>res.json())
                .then(cart=>{

                    let bubble=document.querySelector('.cart-count-bubble');

                    if(bubble){

                        bubble.textContent=cart.item_count;

                    }

                });

                setTimeout(function(){

                    btn.innerHTML="ADD TO CART";
                    btn.disabled=false;

                },1800);

            })

            .catch(function(){

                btn.innerHTML="TRY AGAIN";
                btn.disabled=false;

            });

        });

    });

});